import styled, { css } from 'styled-components';

interface Props {
  checkboxType?: 'task-checkbox' | 'round-checkbox' | 'square-checkbox' | 'switch';
}

export const Checkbox = styled.div<Props>`
  display: flex;
`;

export const Input = styled.input<Props>`
  width: 7px;
  height: 7px;
  border-radius: var(--border-radius-full);
  vertical-align: middle;
  border: 1px solid var(--border-primary);
  appearance: none;
  outline: none;
  cursor: pointer;
  margin: var(--space-0);
  padding: var(--space-7);
  position: relative;
  cursor: pointer;
  opacity: 0.5;

  :checked {
    background-color: var(--brand-primary);
    opacity: 1;
    border: 1px solid var(--brand-primary);
  }

  :checked::before {
    content: '';
    position: absolute;
    right: 50%;
    top: 50%;
    width: 4px;
    height: 10px;
    border: solid var(--text-white);
    border-width: 0 2px 2px 0;
    margin: -1px -1px var(--space-0) -1px;
    -webkit-transform: rotate(45deg) translate(-50%, -50%) scale(0.7);
    -ms-transform: rotate(45deg) translate(-50%, -50%) scale(0.7);
    transform: rotate(45deg) translate(-50%, -50%) scale(0.7);
    z-index: var(--z-index-base);
  }
  ${(props) =>
    props.checkboxType === 'task-checkbox' &&
    css`
      opacity: 1;
      border: 1px solid var(--text-secondary);
      :checked {
        background-color: var(--text-tertiary);
        border: 1px solid var(--text-tertiary);
      }
    `}

  ${(props) =>
    props.checkboxType === 'square-checkbox' &&
    css`
      width: 14px;
      height: 14px;
      border: 1px solid var(--border-secondary);
      border-radius: var(--border-radius-2);
      background-color: var(--background-primary);
      padding: var(--space-0);
      opacity: 1;
    `}
`;
